function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5609 9.31641C14.5259 8.60877 15.1231 7.42833 14.9785 6.10878C14.7809 4.30548 13.1432 2.99999 11.3292 3H4V4L5.44721 4.72361C5.786 4.893 6 5.23926 6 5.61803V14.382C6 14.7607 5.786 15.107 5.44721 15.2764L4 16V17H11.8227C13.9265 17 15.8031 15.4525 15.9845 13.3565C16.1409 11.5507 15.0963 9.96788 13.5609 9.31641ZM9 5H10C11.1045 5 12 5.89539 12 7C12 8.10455 11.1045 9 10 9H9V5ZM11 15H9V11H11C12.1046 11 13 11.8954 13 13C13 14.1046 12.1046 15 11 15Z",
  fill: "currentColor"
});

function SvgFontBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontBold);
export default __webpack_public_path__ + "static/media/font-bold.309bb600.svg";
export { ForwardRef as ReactComponent };